import React, {useState} from 'react';
import { Modal } from "react-morphing-modal";
import "react-morphing-modal/dist/ReactMorphingModal.css";
import { Col} from 'reactstrap';



export const ModalInvoice = (
    { close, divInvoice, ...props }) => {

    return (
        <Modal {...props} padding={false} closeButton={false}  >
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <Col sm="12" style={{ marginTop: "2px" }}>
                {divInvoice}
            </Col>
        </div>
    </Modal>
    
    )
}


